import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import General from "../pages/general/page";
import Packages from "../pages/packages/page";
import AdminPackages from "../pages/admin/Packages";
import Checkout from '../pages/booking/Checkout';
import Payment from '../pages/booking/Payment';
import Bookings from '../pages/admin/Bookings';
import AuditLogs from '../pages/admin/AuditLogs';
import Users from '../pages/admin/Users';
import MyBookings from '../pages/booking/MyBookings';
import Login from "../pages/auth/Login";
import Signup from "../pages/auth/Signup";
import ProtectedRoute from "../components/ProtectedRoute";
import AdminLayout from "../pages/admin/Layout";
import Dashboard from "../pages/admin/Dashboard";
import ApiControl from "../pages/admin/ApiControl";
import PricingControl from "../pages/admin/PricingControl";
import MyProfile from "../pages/profile/MyProfile";
import SavedTravelers from "../pages/profile/SavedTravelers";
import SearchResults from "../pages/search/page";
import FlightsPage from "../pages/flights/page";
import HotelsPage from "../pages/hotels/page";
import UserDashboard from "../pages/dashboard/UserDashboard";
import HajjUmrah from "../pages/hajj-umrah/page";
import PackageCheckout from "../pages/hajj-umrah/PackageCheckout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/general",
    element: <General />,
  },
  {
    path: "/packages",
    element: <Packages />,
  },
  {
    path: "/flights",
    element: <FlightsPage />,
  },
  {
    path: "/hotels",
    element: <HotelsPage />,
  },
  {
    path: "/hajj-umrah",
    element: <HajjUmrah />,
  },
  {
    path: "/booking/checkout",
    element: <Checkout />,
  },
  {
    path: "/package-checkout/:id",
    element: <PackageCheckout />,
  },
  {
    path: "/booking/payment",
    element: <Payment />,
  },
  {
    path: "/booking/confirmation",
    element: <Payment />,
  },
  {
    path: "/search",
    element: <SearchResults />,
  },
  {
    path: "/booking/my-bookings",
    element: <MyBookings />,
  },
  {
    path: "/auth/login",
    element: <Login />,
  },
  {
    path: "/auth/signup",
    element: <Signup />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute requireAdmin={false}>
        <UserDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/profile",
    element: (
      <ProtectedRoute requireAdmin={false}>
        <MyProfile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/profile/travelers",
    element: (
      <ProtectedRoute requireAdmin={false}>
        <SavedTravelers />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin",
    element: (
      <ProtectedRoute requireAdmin={true}>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "api-control",
        element: <ApiControl />,
      },
      {
        path: "pricing-control",
        element: <PricingControl />,
      },
      {
        path: "users",
        element: <Users />,
      },
      {
        path: "packages",
        element: <AdminPackages />,
      },
      {
        path: "bookings",
        element: <Bookings />,
      },
      {
        path: "audit-logs",
        element: <AuditLogs />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;

